import { List } from "immutable";

import {
  calculateProficiencyFade,
  calculateProficiencyFadeCoefficient as seneca_calculateProficiencyFadeCoefficient
} from "@seneca/spacing";

import { ContentStat } from "seneca-common/features/stats/state";

const timesStudiedPerSession = 3;
const averageScoreCeiling = 0.9;
const timesStudiedWeighting = 50;
const averageScoreWeighting = 50;

export function calculateProficiency(contentStat?: ContentStat): number {
  if (!contentStat || !contentStat.spacing) return 0;
  const { timesStudied, averageScore, spacing } = contentStat;

  const timesStudiedPortion = Math.min(
    1,
    timesStudied / (spacing * timesStudiedPerSession)
  );
  const averageScorePortion =
    averageScore !== null
      ? Math.min(1, averageScore! / averageScoreCeiling)
      : 0;
  return Math.round(
    timesStudiedPortion * timesStudiedWeighting +
      averageScorePortion * averageScoreWeighting
  );
}

export function calculateProficiencyWithFade(
  contentStat?: ContentStat,
  // @ts-ignore
  timestamp: string
): number {
  if (!contentStat) return 0;

  return calculateProficiencyFade(
    calculateProficiency(contentStat),
    contentStat.spacing,
    contentStat.lastStudied,
    timestamp
  );
}

export function calculateProficiencyFadeCoefficient(
  contentStat?: ContentStat,
  // @ts-ignore
  timestamp: string
): number {
  if (!contentStat) return 1;

  return seneca_calculateProficiencyFadeCoefficient(
    contentStat.spacing,
    contentStat.lastStudied,
    timestamp
  );
}

export function calculateAverageContentProficiency(
  contentStats: List<ContentStat>,
  totalContents: number,
  calculateProficiencyFunc: (arg0: ContentStat) => number = calculateProficiency
): number {
  const sumProficiency = contentStats.reduce((sum, contentStat) => {
    return sum + calculateProficiencyFunc(contentStat);
  }, 0);
  return sumProficiency / (100 * totalContents);
}

export function calculateAverageContentProficiencyWithFade(
  contentStats: List<ContentStat>,
  totalContents: number,
  timestamp: string
): number {
  return calculateAverageContentProficiency(contentStats, totalContents, meta =>
    calculateProficiencyWithFade(meta, timestamp)
  );
}

export function calculateAverageContentProficiencyFadeCoefficient(
  contentStats: List<ContentStat>,
  totalContents: number,
  timestamp: string
): number {
  const sumProficiencyFade = contentStats.reduce((sum, contentStat) => {
    return sum + calculateProficiencyFadeCoefficient(contentStat, timestamp);
  }, 0);

  return sumProficiencyFade / totalContents;
}

export { calculateProficiencyFade };
